module.exports = __webpack_public_path__ + "media/packs/images/flags/PT-fdcb6fbb860c5828fdc6fc74d793a396.svg";